module.exports = __webpack_public_path__ + "img/burger--active.4fa3c2ae.svg";